export default "__VITE_ASSET__Dai92E4k__"